import Cookies from "universal-cookie";

// Utility function to decode JWT token
export const decodeJWT = (token: string): any => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    console.error("Error decoding JWT:", err);
    return null;
  }
};

// Check if user has admin role
export const isAdmin = (): boolean => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    if (!token) return false;

    const decodedToken = decodeJWT(token);
    const roles = decodedToken?.user?.roles || [];
    return Array.isArray(roles) && roles.includes("admin");
  } catch (err) {
    console.error("Error checking admin role:", err);
    return false;
  }
};

// Check if user has club_admin role
export const isClubAdmin = (): boolean => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    if (!token) return false;

    const decodedToken = decodeJWT(token);
    const roles = decodedToken?.user?.roles || [];
    return Array.isArray(roles) && roles.includes("club_admin");
  } catch (err) {
    console.error("Error checking club_admin role:", err);
    return false;
  }
};

// Get user roles from JWT
export const getUserRoles = (): string[] => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");
    if (!token) return [];

    const decodedToken = decodeJWT(token);
    return decodedToken?.user?.roles || [];
  } catch (err) {
    console.error("Error getting user roles:", err);
    return [];
  }
};
